import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from 'rxjs';
import { RecadoDto } from '../../../models/recado-dto.model';
import { AuthService } from 'app/shared/auth/auth.service';
import { AbRecado } from 'app/abstract/full-pages/recado/recado.abstract';

@Injectable({ providedIn: 'root' })
export class RecadoService extends AbRecado {
  user: any;

  constructor(
    httpClient: HttpClient,
    private authService: AuthService,
  ) {
    super(httpClient);
  }

  public getAllRecados(filter: AppFilter): Observable<any> {
    return this.get(`recados/recado/filter/${filter.encode()}`);
  }

  public getAllRecadosByPessoa(filter: AppFilter): Observable<any> {
    return this.get(`recados/recado/filter_pessoa/${filter.encode()}`);
  }

  public saveRecado(recado: RecadoDto): Observable<any> {
    return this.save("recados/recado/", recado);
  }

  public getComunicado(recado: RecadoDto): Observable<any> {
    return this.post("recados/recado/gerar/", recado);
  }

  public uploadAnexo(recadoId: number, anexos): Observable<any> {
    return this.http.post(`${this.url}recadoanexos/upload/${recadoId}`, anexos);
  }

  public deletar(id: number) {
    return this.delete("recados/", id);
  }

  public getAllRecadoPessoa(filter: AppFilter): Observable<any> {
    return this.get(`recadopessoa/filter/${filter.encode()}`);
  }

  public getVisualizacoes(recadoId: number): Observable<any> {
    return this.get(`recadopessoa/visualizacoes/${recadoId}`);
  }

  isIntegrador(): Boolean {
    this.user = this.authService.getUsuarioStorage();
    return this.user.integrador;
  }

}